import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Button } from "../components/button";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Login() {
  const API_URL = process.env.REACT_APP_API_URL;
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({ mode: "onChange" });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.post(`${API_URL}/api/admin/login`, data);
      if (response.data != null) {
        alert("Login Successful");
        localStorage.setItem("authToken", response.data);
        navigate("/dashboard");
        window.location.reload();
      } else {
        setError("Invalid username or password.");
        alert(error);
      }
    } catch (err) {
      setError("Something went wrong while log in. Please try again later");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center bg-[#545454]">
      <title>Login | HairBank</title>
  
      {/* Updated HairBank Header */}
      <div className="w-96 mt-20 sm:mt-24 md:mt-32 lg:mt-44 xl:mt-52 flex justify-center">
        <h1 className="text-6xl font-bold p-4 text-[#eed495] text-center border-2 leading-tight">
          HAIRBANK
        </h1>
      </div>
  
      {/* Form Container */}
      <div className="w-full max-w-screen-sm flex flex-col items-center">
        <h4 className="w-full font-semibold text-white text-center text-5xl mb-14 mt-28">
          Welcome
        </h4>
        <form onSubmit={handleSubmit(onSubmit)}>
  
          {/* ID Field */}
          <div className="flex items-center mb-4">
            <div className="w-full">
              <label htmlFor="name" className="text-white">
                ID
              </label>
            </div>
            <div>
              <input
                {...register("name", {
                  required: "ID is required",
                })}
                name="name"
                required
                type="name"
                className="input"
              />
            </div>
          </div>
          {errors.name?.message && (
            <div className="text-2xl text-red-400 text-center">
              <span>{errors.name?.message}</span>
            </div>
          )}
  
          {/* Password Field */}
          <div className="flex items-center mb-4">
            <div className="w-full">
              <label htmlFor="password" className="text-white">
                PW
              </label>
            </div>
            <div>
              <input
                {...register("password", {
                  required: "Password is required",
                })}
                name="password"
                type="password"
                className="input"
              />
            </div>
          </div>
          {errors.password?.message && (
            <div className="text-2xl text-red-400 text-center">
              <span>{errors.password?.message}</span>
            </div>
          )}
  
          {/* Submit Button */}
          <div className="flex justify-center mt-6">
            <Button
              canClick={isValid}
              isLoading={isLoading}
              actionText={"LogIn"}
            />
          </div>
        </form>
      </div>
    </div>
  );
  
}
export default Login;
